import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Alert
} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import FrameworkManagementForm from "./framework_management_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

const FrameworkManagementTable = ({
    rowKey = "frameworkcode",
    keyPrefix = "cataloging.framework_management",
    showAllColumns = true,
    propsShowColumns,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }, //selectInfo
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const navigate = useNavigate()
    const columns = [
        {
            title: t("frameworkcode"),
            key: "frameworkcode",
            dataIndex: "frameworkcode",
            align: "center",
        },
        {
            title: t("frameworktext"),
            key: "frameworktext",
            dataIndex: "frameworktext",
            align: "center",
        },
    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ['question_and_answer_data', 'title'])
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();


    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const FrameworkManagementController = useCRUDController({
        apiRoute: "/koha/bib/framework",
        onFinish,
        onBefore
    })
    useEffect(() => {
        checkAll();

    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (<Row>
        <Col span={24}>
            <ProTableOt
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <Col span={8}>
                        <Alert
                            type={"warning"}
                            // message={t('default_framework_locked')}
                            description={t('default_framework_locked')}
                        />
                    </Col>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return []
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return FrameworkManagementController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }

                propsPatchProcess={(data) => {
                    return {
                        ...data,
                        axiosMode: "patch"
                    }
                }}
                initialValues={{
                    "axiosMode": "post",
                }}
                propsPostOnBefore={(data) => {
                    return {
                        ...data,
                        axiosMode: "post"
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (formData) => {

                            let postData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }

                            })
                            FrameworkManagementController.postData(postData)
                        },
                        patchData: (formData) => {
                            let patchData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }
                            })
                            FrameworkManagementController.patchData(patchData)
                        },
                        deleteData: (data)=>{
                            let newData = data.filter(ele=>ele?.frameworkcode!=="")
                            FrameworkManagementController.deleteData(newData)
                        }
                    }
                }}
                PropsPatchForm={<FrameworkManagementForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={permission_level === 1 ? true : false}
                propsDelete={permission_level === 1 ? true : false}
                propsPost={permission_level === 1 ? true : false}
                propsWidth={800}
                scroll={{
                    x: "100%",
                }}
                extraActionRender={(record) => {
                    return (
                    permission_level === 1 ? 
                    <Col>
                        <Button
                            onClick={() => {
                                navigate(`../tag_structure_management?frameworkcode=${record?.frameworkcode}`)
                            }}>
                            {t('edit_field')}
                        </Button>
                    </Col>
                    : <></>
                )
                }}
            />
        </Col>
    </Row>)

}
const FrameworkManagement = ({
    keyPrefix = "cataloging.framework_management",
    permission_level = null, 
}) => {

    return (
        <Row
            gutter={[10, 20]}
        >

            <Col span={24}>
                <FrameworkManagementTable keyPrefix={keyPrefix} permission_level={permission_level} />
            </Col>
        </Row>
    );
};
export { FrameworkManagementTable }
export default FrameworkManagement;
